import React from "react";
import { Link } from "react-router-dom";
import logo from "../../../images/logo.png";
import "./Header.css";

const Header = () => {
    return (
        <div>
            <nav class="navbar navbar-expand-lg navbar-light">
                <div class="container-fluid">
                    <Link class="navbar-brand link logo" to="/home">
                        <img src={logo} alt="" />
                    </Link>
                    <button
                        class="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                        aria-controls="navbarNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarNav">
                        <ul class="navbar-nav ms-auto">
                            <li class="nav-item">
                                <Link
                                    class="nav-link active link"
                                    aria-current="page"
                                    to="/home"
                                >
                                    Home
                                </Link>
                            </li>
                            <li class="nav-item">
                                <Link class="nav-link link" to="/about">
                                    About
                                </Link>
                            </li>
                            <li class="nav-item">
                                <Link class="nav-link link" to="/work">
                                    Works
                                </Link>
                            </li>
                            <li class="nav-item">
                                <Link class="nav-link link" to="/blog">
                                    Blogs
                                </Link>
                            </li>
                            <li class="nav-item">
                                <Link class="nav-link link" to="/contact">
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Header;
